import { render, staticRenderFns } from "./SubscriptionFormSuccessInPopUp.vue?vue&type=template&id=eed9c8b0&scoped=true&"
import script from "./SubscriptionFormSuccessInPopUp.vue?vue&type=script&lang=js&"
export * from "./SubscriptionFormSuccessInPopUp.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionFormSuccessInPopUp.vue?vue&type=style&index=0&id=eed9c8b0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eed9c8b0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiButton: require('/app/components/UI/UiButton.vue').default})
